import React from 'react';
import {
    Typography,
    Box,
} from "@mui/material";

import { _date } from "../../../utils/helpers";

export const ExamScoreColumns = () => [
    {
        id: "title_en",
        label: "Title",
        render: (value, row) => {
            const imageCount = Array.isArray(row.images) ? row.images.length : (row.image ? 1 : 0);
            return (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                    {row.image && (
                        <Box sx={{ position: 'relative' }}>
                            <Box
                                component="img"
                                src={row.image}
                                alt=""
                                sx={{
                                    width: 72,
                                    height: 72,
                                    objectFit: 'cover',
                                    borderRadius: 1,
                                    border: '1px solid',
                                    borderColor: 'divider',
                                }}
                            />
                            {imageCount > 1 && (
                                <Box
                                    sx={{
                                        position: 'absolute',
                                        right: 4,
                                        bottom: 4,
                                        bgcolor: 'rgba(0,0,0,0.7)',
                                        color: '#fff',
                                        fontSize: 11,
                                        lineHeight: 1,
                                        px: 0.75,
                                        py: 0.25,
                                        borderRadius: 1,
                                    }}
                                >
                                    +{imageCount - 1}
                                </Box>
                            )}
                        </Box>
                    )}
                    <Box>
                        <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {row.title_en || row.title_hy || row.title_ru || '—'}
                        </Typography>
                        {(row.title_hy || row.title_ru) && (
                            <Typography variant="caption" color="text.secondary" display="block">
                                {[row.title_hy, row.title_ru].filter(Boolean).join(' · ')}
                            </Typography>
                        )}
                    </Box>
                </Box>
            );
        }
    },
    {
        id: "date",
        label: "Date",
        render: (value) => {
            return (
                <Typography sx={{ color: "text.secondary", textAlign: 'center' }}>
                    {_date(value, { relative: true })}
                </Typography>
            );
        }
    },
    {
        id: "created_at",
        label: "Created Date",
        render: (value) => {
            return (
                <Typography sx={{ color: "text.secondary", textAlign: 'center' }}>
                    {_date(value, { relative: true })}
                </Typography>
            );
        }
    },
];
